import { render, staticRenderFns } from "./UserEmailTextarea.vue?vue&type=template&id=e9162970"
import script from "./UserEmailTextarea.vue?vue&type=script&lang=js"
export * from "./UserEmailTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports